import { Stack, styled } from '@mui/material';

/**
 * Selection action bar floating over a grid's top-right. The wrapper takes no
 * height, so the stack sits on the grid's row-group panel rather than pushing
 * the grid down. Used by the KPI request grids, KPI > Companies and the Field
 * Manager — keep the two in step, they are one component in two parts.
 */
export const ActionButtonWrapper = styled('div')`
  position: relative;
  z-index: 1;
`;

export const ActionButtonStack = styled(Stack)`
  position: absolute;
  z-index: 1;
  right: 0rem;
  padding: 0.5rem 0.25rem 0.25rem;
  gap: 0.5rem;
`;
